import React from 'react'
import { useTranslation } from 'react-i18next'
import TermsAndConditionsContent from './TermsAndConditionsContent'
import ComponentHeader from '../ComponentHeader/ComponentHeader'
import PanelSurface from '../PanelSurface/PanelSurface'
import styles from './TermsAndConditions.module.css'

interface TermsAndConditionsProps {
  children: React.ReactNode
}

const TermsAndConditions: React.FC<TermsAndConditionsProps> = ({
  children,
}) => {
  const { t } = useTranslation()

  return (
    <PanelSurface className={styles.termsAndConditions}>
      <ComponentHeader>{t('betRule.termsAndConditions')}</ComponentHeader>

      <div className="px-4 md:px-8 py-6 md:py-8 space-y-6">
        <TermsAndConditionsContent>{children}</TermsAndConditionsContent>
      </div>
    </PanelSurface>
  )
}

export default TermsAndConditions
